import { Affix as AntAffix } from 'antd';
import type { AffixProps } from 'antd';
import type { ComponentType } from 'react';

export const Affix: ComponentType<AffixProps> = AntAffix;

export type { AffixProps };
